export const regionalState = {
  JHR: 'Johor',
  KTN: 'Kelantan',
  MLK: 'Malacca',
  PHG: 'Pahang',
  TRG: 'Terengganu',
  KUL: 'Kuala Lumpur',
  SGR: 'Selangor',
  PRK: 'Perak',
  PNG: 'Penang',
}
